import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-date-and-time-picker" }

import MDatePicker from "@/BasicComponentLibrary/MDatePicker.vue";
import MTimePicker from "@/BasicComponentLibrary/MTimePicker.vue";
import moment from "moment";
import { watch } from "vue";
import { watchEffect } from "vue";
import { reactive, ref } from "vue";
import { useI18n } from "vue-i18n";

//#region Constants

const DEFAULT_DATE_V_MODEL_FORMAT = "YYYY-MM-DD";
const DEFAULT_TIME_V_MODEL_FORMAT = "HH:mm";
type ViewModel = { dateSelection: string | null; timeSelection: string | null; disabled: boolean };

export default /*#__PURE__*/_defineComponent({
  __name: 'MDateAndTimePicker',
  props: {
    value: {},
    validation: {}
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const TODAY = ref(moment());
const DEFAULT_DATE_TIME_V_MODEL_FORMAT = `${DEFAULT_DATE_V_MODEL_FORMAT} ${DEFAULT_TIME_V_MODEL_FORMAT}`;

//#endregion

//#region General


const { t: $t } = useI18n();
//#endregion

//#region Viewmodel
const vm = reactive<ViewModel>({ dateSelection: null, timeSelection: null, disabled: false });
//#endregion

watch(
  () => props.value,
  (nv, ov) => {
    if (nv != ov) {
      const split = nv.split(" ");
      vm.dateSelection = split[0] ?? null;
      vm.timeSelection = split[1] ?? null;
    }
  },
  { immediate: true }
);

watchEffect(() => {
  let formattedValue = "";

  if (vm.dateSelection && vm.timeSelection) {
    formattedValue = moment(`${vm.dateSelection} ${vm.timeSelection}`).format(DEFAULT_DATE_TIME_V_MODEL_FORMAT);
  } else if (vm.dateSelection && !vm.timeSelection) {
    formattedValue = moment(`${vm.dateSelection}`).format(DEFAULT_DATE_V_MODEL_FORMAT);
  } else if (!vm.dateSelection && vm.timeSelection) {
    vm.dateSelection = TODAY.value.format(DEFAULT_DATE_V_MODEL_FORMAT);
    formattedValue = moment(`${vm.dateSelection} ${vm.timeSelection}`).format(DEFAULT_DATE_TIME_V_MODEL_FORMAT);
  }

  emits("input", formattedValue);
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(MDatePicker, {
      modelValue: vm.dateSelection,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.dateSelection) = $event)),
      "data-cy": "date-picker",
      placeholder: _unref($t)('Placeholder.Date'),
      disabled: vm.disabled,
      "is-invalid": _ctx.validation.length > 0
    }, null, 8, ["modelValue", "placeholder", "disabled", "is-invalid"]), [
      [_directive_tooltip, _ctx.validation]
    ]),
    _createVNode(MTimePicker, {
      modelValue: vm.timeSelection,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((vm.timeSelection) = $event)),
      placeholder: _unref($t)('Placeholder.Time'),
      disabled: vm.disabled,
      "data-cy": "time-picker"
    }, null, 8, ["modelValue", "placeholder", "disabled"])
  ]))
}
}

})